import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import TitleTextButton from '../modules/TitleTextButton';
import Header_2 from '../headers/Header_2';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import SEO from '../components/Seo';
import Button from '../components/Button';

export const Sanierungen = () => {

    const [activeTab, setActiveTab] = useState("");

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hoveredId, setHoveredId] = useState(null);
    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".item_inner h3"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [tabData, setTabData] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/sanierungen?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.projekte-portfolio][populate][neubauprojekte_posts][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.news][populate][aktuelles][populate][Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*&populate[Metadaten]=*");


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul)
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const getTabsData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&sort[0]=Page_Titel&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[neubauprojekte_kategoriens][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Modul][on][modules.neubauprojekte-registerkarten-daten][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.quote][populate]=*&populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Button]=*&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Videominiatur]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Video]=true&populate[Neubauprojekte_Tab_Data][populate][neubauprojekte_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Button][populate]=*&populate[Standort][populate]=*&populate[Beitrags_Miniaturbild][populate]=true&populate[Modul][on][modules.facts-modul][populate][Facts][populate][Icon][populate]=*&populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Standort][populate]=*&populate[sanierungen_tags][populate]=*");

            // const response = await fetch("https://backend.bgzurlinden.ch/api/sanierungen-beitrags?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Metadaten]=*&populate[Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.short-titel-titel-text-button][populate]=*&populate[Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Tab_Data][populate][sanierungen_registerkarten_daten][populate][Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[sanierungen_tags][populate]=*");


            const data = await response.json();

            const sanierungenPosts =
                data?.data?.filter(
                    (item) =>
                        item?.Page_Template ===
                        "Sanierungen"
                ) || [];

            setTabData(sanierungenPosts);

            // if (data.data) {
            //     setTabData(data?.data);
            // }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
        getTabsData()
    }, [])


    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    const [visibleCount, setVisibleCount] = useState(9);


    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get("id") === "projekte") {
            setTimeout(() => {
                const element = document.getElementById("projekte");

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            }, 300);
        }
    }, [location.search]);

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-bauprojekte" activePage='bauprojekte' />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>

                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }

                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="blue" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

            <section className='pb-10 sec-blue-color'  id='projekte'>
                <div className='container'>
                    <div className='page_tabs mt-5 sanierungen_list_wrapper'>
                        <div className="row">
                            {tabData?.slice(0, visibleCount)?.map((item, index) => (
                                <div key={index} className="col-sm-6 col-lg-4 col-item mt-4">
                                    <Link to={`/sanierungen/${item?.slug}`} className="item_inner">
                                        <figure className="mb-0">
                                            <div className={`fig-image ${hoveredId === item.id ? "hide_cursor" : ""}`}
                                                onMouseMove={mouseMove}
                                                onMouseEnter={() => setHoveredId(item.id)}
                                                onMouseLeave={() => setHoveredId(null)}>
                                                <img src={`https://backend.bgzurlinden.ch${item?.Beitrags_Miniaturbild?.url}`} alt="#" className="w-100" />
                                                <div className='img_tags'>
                                                    {item?.sanierungen_tags?.map((tag, i) => (
                                                        <span key={i} className={`bg-${tag?.Farbe?.split(" ")[0]}`}>{tag?.Titel}</span>
                                                    ))}
                                                </div>
                                                {hoveredId === item.id && (
                                                    <div className="image_cursor" style={{
                                                        left: `${position.x}px`,
                                                        top: `${position.y}px`,
                                                    }}>
                                                        <img src="/images/cursor-blue.png" alt="" />
                                                    </div>
                                                )}
                                            </div>
                                            <figcaption>
                                                <h3 className="text-darkgrey fw-550 fs_26">{item?.Page_Titel}</h3>
                                                {/* {item?.Bannerbereich[0]?.Beschreibung && (
                                                    <p>{truncateBlocks(item?.Bannerbereich[0].Beschreibung, 90)}</p>
                                                )} */}
                                                {item?.Ubersichtstext && (
                                                    <p>{item?.Ubersichtstext}</p>
                                                )}

                                                {item?.Button && (
                                                    <Button component={item?.Komponente} pdf={[item?.PDF]} buttons={[item?.Button]} slug={`/sanierungen/${item?.slug}`} />
                                                )}
                                            </figcaption>
                                        </figure>
                                    </Link>
                                </div>
                            ))}
                        </div>
                        {visibleCount < tabData?.length && (
                            <div className='btn-container d-flex justify-content-center mt-4'>
                                <button
                                    className='button border-btn btn-theme-color'
                                    onClick={() => setVisibleCount((prev) => prev + 9)}
                                >
                                    mehr
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    )
}